<ion-grid class="team">
    <ion-row class="header">
        <ion-col size="2"><span>{{ 'headEvaluation.colaborator' | translate }}</span></ion-col>
        <ion-col [size]="colSize"><span>{{ 'headEvaluation.selfEvaluation' | translate }}</span></ion-col>
        <ng-container *ngFor="let area of areas">
            <ion-col [size]="colSize">
                <span>{{ getText( area?.globalizationConfig, 'title' ) }}</span>
            </ion-col>
        </ng-container>
        <ion-col [size]="colSize"><span>{{ 'headEvaluation.managerEvaluation' | translate }}</span></ion-col>
        <ion-col size="1.25"><span>{{ 'headEvaluation.evaluationsAverage' | translate }}</span></ion-col>
        <ion-col size="1.25"><span>{{ 'headEvaluation.finalAverageHead' | translate }}</span></ion-col>
        <ion-col size="1"><span>{{ 'headEvaluation.status' | translate }}</span></ion-col>
    </ion-row>
    <ion-row class="body" *ngFor="let userEvaluation of displayedUserEvaluations">
        <app-subordinate-user-list
                style="width: 100%;"
                [areas]="areas"
                [colSizeToAreas]="colSizeToAreas"
                [colSize]="colSize"
                [userEvaluation]="userEvaluation"
                [cycleParticipantId]="cycleParticipantId"
                [level]="0"
                [cycleId]="cycleId"
                (getEvaluations)="getEvaluations.emit()">
        </app-subordinate-user-list>
    </ion-row>
</ion-grid>